import React from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import { IntlProvider, addLocaleData } from 'react-intl'
import en from 'react-intl/locale-data/en'
import zh from 'react-intl/locale-data/zh'

addLocaleData(en)
addLocaleData(zh)

const Provider = ({ store, children }) => (
  <ReduxProvider store={store}>
    <IntlProvider locale="zh">
      {children}
    </IntlProvider>
  </ReduxProvider>
)

export default Provider



// WEBPACK FOOTER //
// ./containers/Root/Provider.js